/**
 * L'état d'interface de la coquille de l'élève, pur : la feuille « moi » ouverte ou non, et le
 * profil vers lequel une bascule est en cours. Séparé de `useStudentShellState` pour se tester
 * sans charger le store (que les actions d'api importent).
 */
export type StudentShellUiState = {
    sheetOpen: boolean
    /** Le profil vers lequel une bascule est en cours. */
    switchingId: string | number | null
}

export type StudentShellUiAction =
    | { type: "OPEN_SHEET" }
    | { type: "CLOSE_SHEET" }
    | { type: "START_SWITCH"; id: string | number }
    | { type: "END_SWITCH" }

export const initialStudentShellUiState: StudentShellUiState = { sheetOpen: false, switchingId: null }

export function studentShellUiReducer(state: StudentShellUiState, action: StudentShellUiAction): StudentShellUiState {
    switch (action.type) {
        case "OPEN_SHEET":
            return state.sheetOpen ? state : { ...state, sheetOpen: true }
        case "CLOSE_SHEET":
            return state.sheetOpen ? { ...state, sheetOpen: false } : state
        // Basculer referme la feuille : la bascule se suit sur la pastille de l'en-tête.
        case "START_SWITCH":
            return { sheetOpen: false, switchingId: action.id }
        case "END_SWITCH":
            return state.switchingId == null ? state : { ...state, switchingId: null }
    }
}
